import { AgrEnvironment } from '@next/core-lib/environment';

export class Environment extends AgrEnvironment {
  // add app specific environment variables here
  MY_OFFICE_URL: string;
  INSTANT_ORDER: boolean;
  IDENTIFICATION_TYPES_NL: string[];
  IDENTIFICATION_WARNING_PERIOD: string;
  DELIVERY_TIME_WINDOW_DISABLED: boolean;
  SHOW_DISABLED_LOCATION_BADGE: boolean;
  constructor(env: Environment) {
    super(env);
  }
}
